<template>
    <div class="queue-management pa-6 d-flex flex-column gap-6" data-testid="queue-management">
        <div class="d-flex align-center">
            <PageHeader title="Queue Management" :loading="loading" :is-flow-enabled="isFlowEnabled" @refresh="refreshData"
                data-testid="queue-management__header" @flow-dispatch="flowDispatch" />
        </div>
        <div class="d-flex flex-column gap-4">
            <div class="d-flex align-center gap-4" data-testid="queue-management__subheader">
                <h5 class="font-weight-regular">Multi-Message Composer</h5>
                <v-chip class="textUppercase">Batch Mode</v-chip>
            </div>
            <v-card class="queue-management__message-composer" data-testid="queue-management__message-composer">
                <v-card-text>
                    <v-form ref="queueForm">
                        <v-row no-gutters class="gap-6" data-testid="queue-management__message-composer-header">
                            <v-col cols="7">
                                <div class="queue-management__dispatch-label">Payload Content (JSON)</div>
                                <v-textarea solo rows="7" v-model="queueObject.messages" :rules="jsonRules" placeholder='{"key": "value"}' data-testid="queue-management__payload-input"></v-textarea>
                            </v-col>
                            <v-col cols="4">
                                <v-card class="queue-management__dispatch-card" elevation="0"
                                    data-testid="queue-management__dispatch-card">
                                    <div class="queue-management__dispatch-label mt-5">QUEUE NAME</div>
                                    <v-select v-model="queueObject.queueName" :items="isQueueList" outlined dense
                                        :rules="[rules.required]" class="queue-management__queue-select"
                                        data-testid="queue-management__queue-select"
                                        item-value="value" item-text="name" @change="peekQueue({ queueName: queueObject.queueName })" />

                                    <base-button primary block large class="queue-management__dispatch-btn mt-5"
                                        label="Dispatch Batch" append-icon="mdi-arrow-right" :loading="loading" @click="queueSend"
                                        data-testid="queue-management__dispatch-btn" />
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
            </v-card>
        </div>

        <QueueManagementTable :items="queueDataList" :loading="tableLoading" data-testid="queue-management__peek-table" />

        <FlowDialog v-model="flowDialog" data-testid="queue-management__flow-dialog" />
    </div>
</template>

<script>
import PageHeader from '../../components/PageHeader.vue';
import QueueManagementTable from './components/QueueManagementTable.vue';
import FlowDialog from './components/FlowDialog.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'QueueManagement',
    components: {
        PageHeader,
        QueueManagementTable,
        FlowDialog,
    },
    data() {
        return {
            queueObject: { messages: '', queueName: '' },
            flowDialog: false,
            rules: {
                required: v => !!v || 'This field is required',
            },
        };
    },
    computed: {
        ...mapGetters({
            isQueueList: 'isQueueList',
            isFlowEnabled: 'isFlowEnabled',
        }),
        ...mapGetters('varianceanalysis/queuemanagement', ['queueDataList', 'tableLoading', 'loading']),
        jsonRules() {
            return [
                v => !!v || 'This field is required',
                v => !v || this.isValidJSON(v) || 'Invalid JSON format',
            ];
        },
    },
    watch: {
        isQueueList: {
            immediate: true,
            handler(list) {
                if (list && list.length && !this.queueObject.queueName) {
                    this.queueObject = { ...this.queueObject, queueName: list[0].value };
                    this.peekQueue({ queueName: list[0].value });
                }
            },
        },
    },
    created() {
        this.refreshData();
    },
    methods: {
        ...mapActions('varianceanalysis/queuemanagement', ['peekQueue', 'sendQueue']),
        flowDispatch() {
            this.flowDialog = true;
        },
        refreshData() {
            if (!this.queueObject.queueName) return;
            this.peekQueue({ queueName: this.queueObject.queueName });
        },
        isValidJSON(str) {
            try {
                JSON.parse(str);
                return true;
            } catch {
                return false;
            }
        },
        async queueSend() {
            if (!this.$refs.queueForm.validate()) return;
            if (!this.isValidJSON(this.queueObject.messages)) {
                this.$store.commit('sbError', 'Please enter valid JSON in the payload field', { root: true });
                return;
            }
            const success = await this.sendQueue(this.queueObject);
            if (success) {
                this.queueObject.messages = '';
                this.$refs.queueForm?.resetValidation();
            }
        },
    },
    beforeDestroy() {
        this.$store.commit('varianceanalysis/queuemanagement/RESET_STATE');
        this.queueObject = { messages: '', queueName: '' };
    },
};
</script>


<style lang="scss" src="./QueueManagement.scss"></style>